<template>
  <answer-template
    :answer-type="'quick reply'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'quick-reply-answer'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Send quick reply</template>
    <template v-slot:content>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">Text</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <input
                class="input is-small"
                type="text"
                v-model="inputData.text"
                placeholder="Quick reply title"
                @keyup="onTextChange"
                required
              />
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label is-small">Items</label>
        <div class="control has-fullwidth">
          <div class="tabs is-small is-boxed no-margin">
            <ul class="no-padding items-horizontal-scroll">
              <li
                v-for="(btn, index) in inputData.buttons"
                :class="{'is-active': index === activeTab}"
                :key="uid+'-'+index"
              >
                <a @click="activeTab = index">
                  <span class="truncate">{{getLabel(index, btn)}}</span>
                  <span class="icon is-small remove-btn" @click.prevent="deleteItem(index)">
                        <font-awesome-icon icon="times"></font-awesome-icon>
                      </span>
                </a>
              </li>
              <li>
                <button class="button is-white is-small" @click="addItem">
                      <span class="icon">
                        <font-awesome-icon icon="plus"></font-awesome-icon>
                      </span>
                  <span>Item</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="tab-box" v-if="selectedItem">
            <div class="field">
              <div class="control is-expanded">
                <input
                  type="text"
                  class="input is-small"
                  v-model="selectedItem.label"
                  placeholder="Item title"
                  @keyup="onTextChange"
                />
              </div>
            </div>
            <div class="field has-addons">
              <div class="control">
                <div class="select is-small">
                  <select v-model="selectedItem.type" @change="toggleType">
                    <option value="text_button">Text</option>
                    <option value="category_button" v-if="dataInSameLevel && dataInSameLevel.length > 0" >Category</option>
                    <!-- <option value="payload">Payload</option> -->
                  </select>
                </div>
              </div>
              <div class="control is-expanded">
                <!-- <input
                  v-if="selectedItem.type === 'payload'"
                  type="text"
                  class="input is-small"
                  v-model="selectedItem.payload"
                  @keyup="onTextChange"
                  placeholder="Payload text"
                  maxlength="300"
                /> -->
                <input
                  v-if="selectedItem.type === 'text_button'"
                  type="text"
                  class="input is-small"
                  v-model="selectedItem.text"
                  @keyup="onTextChange"
                  placeholder="Enter text"
                  maxlength="300"
                />
                 <select
                  v-else-if="selectedItem.type === 'category_button' && dataInSameLevel && dataInSameLevel.length > 0"
                  class="input is-small"
                  v-model="selectedItem.payload"
                  @change="onTextChange"
                  :disabled="inputData.isDefaultCarousel || dataInSameLevel && dataInSameLevel.length === 0"
                >
                  <option v-if="!selectedItem.payload" value="" disabled selected>Select category</option>
<!--                  <option v-for="data in dataInSameLevel" :key="data.id" :value="data.categoryId">-->
                  <option v-for="data in dataInSameLevel" :key="data.id" :value="data.id">
                    {{ data.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'QuickReplyAnswer',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'quick_reply',
          text: '',
          buttons: [],
        };
      },
    },
    index: {
      type: Number,
    },
    uid: {
      type: String,
    },
    dataInSameLevel: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  mounted() {
    this.activeTab = 0;
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    addItem() {
      if (!this.inputData.buttons) {
        this.inputData.buttons = [];
      }
      this.inputData.buttons.push({
        type: 'text_button',
        title: '',
        payload: '',
        text: '',
      });
      this.toggleDirty();
    },
    deleteItem(index) {
      this.inputData.buttons.splice(index, 1);
      setTimeout(() => {
        this.activeTab = 0;
      });
      this.toggleDirty();
    },
    getLabel(index, btn) {
      if (btn && btn.label) {
        return btn.label;
      }
      return `Item ${index + 1}`;
    },
    toggleDirty() {
      this.$emit('dirty');
    },
    onTextChange() {
      this.toggleDirty();
    },
    toggleType() {
      // const item = this.selectedItem;
      // if (item) {
      //   if (item.type === 'payload') {
      //     item.text = '';
      //   } else if (item.type === 'text') {
      //     item.payload = '';
      //   }
      // }
      this.toggleDirty();
    },
  },
  computed: {
    selectedItem() {
      if (this.inputData && this.inputData.buttons) return this.inputData.buttons[this.activeTab];
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-reply-answer {
  .answer-box {
    width: 100%;
    .has-fullwidth {
      width: 100%;
    }
    .tab-box {
      border: 1px solid #ddd;
      border-top: none;
      padding: 10px;
      border-radius: 0 0 5px 5px;
    }
    .remove-btn {
      color: #ddd;
      &:hover {
        color: #ff3860;
      }
    }
    .truncate {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.items-horizontal-scroll {
    width: 300px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}
</style>
